import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";
import { AccountProfile } from "./AccountProfileSlice";

export const getVideoPreferences = createAsyncThunk(
    "getVideoPreferences",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/user/preferences/video/`);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const updateVideoPreferences = createAsyncThunk(
    "updateVideoPreferences",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.patch(`/user/preferences/video/`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const VideoPreferencesSlice = createSlice({
    name: "VideoPreferences",
    initialState: {
        autoplay: true,
        mute_video: false,
        loaded: false,
        loading: false,
        updating: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        // hydrate from the profile API response, which nests the same preferences.
        // New accounts (or accounts that haven't saved a video preference yet)
        // come back with `preferences: {}` - that's still truthy, so guard on the
        // individual fields too, otherwise we'd blindly overwrite the sane
        // defaults above with `undefined`.
        builder.addCase(AccountProfile.fulfilled, (state, action) => {
            const preferences = action.payload?.preferences;
            if (preferences) {
                if (preferences.autoplay !== undefined) {
                    state.autoplay = preferences.autoplay;
                }
                if (preferences.mute_video !== undefined) {
                    state.mute_video = preferences.mute_video;
                }
                state.loaded = true;
            }
        });

        builder.addCase(getVideoPreferences.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getVideoPreferences.fulfilled, (state, action) => {
            state.loading = false;
            state.loaded = true;
            if (action.payload?.autoplay !== undefined) {
                state.autoplay = action.payload.autoplay;
            }
            if (action.payload?.mute_video !== undefined) {
                state.mute_video = action.payload.mute_video;
            }
        });
        builder.addCase(getVideoPreferences.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(updateVideoPreferences.pending, (state) => {
            state.updating = true;
            state.error = null;
        });
        builder.addCase(updateVideoPreferences.fulfilled, (state, action) => {
            state.updating = false;
            state.loaded = true;
            if (action.payload?.autoplay !== undefined) {
                state.autoplay = action.payload.autoplay;
            }
            if (action.payload?.mute_video !== undefined) {
                state.mute_video = action.payload.mute_video;
            }
        });
        builder.addCase(updateVideoPreferences.rejected, (state, action) => {
            state.updating = false;
            state.error = action.payload;
        });
    },
});

export default VideoPreferencesSlice.reducer;
